/**
 * "What this stage needs", as a group. One component, because six stages show
 * it and they should not each decide how.
 */
import { GroupCard } from '../../../shared/GroupCard';
import { RequirementList } from './RequirementList';
import type { Requirement } from './types';

export function StageNeeds({ requirements }: { requirements: Requirement[] }) {
  // Only when there is something under it. An empty group reads as a section
  // that failed to load.
  if (requirements.length === 0) return null;
  return (
    <GroupCard title="What this stage needs" list>
      <RequirementList requirements={requirements} />
    </GroupCard>
  );
}
